import { combineReducers } from "redux";
import metaReducer from "./metaReducer";
import partReducer from "./partReducer";
import userReducer from "./userReducer";
export default combineReducers({ metaReducer, partReducer, userReducer });
